import { AgmCoreModule, LAZY_MAPS_API_CONFIG } from '@agm/core';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { HttpModule, RequestOptions, XHRBackend } from '@angular/http';
import { Router } from '@angular/router';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { ToastrModule } from 'ngx-toastr';

import { environment } from '../../environments/environment';
import { GoogleMapsConfig } from './config/google-maps-config';
import { createTranslateLoader } from './factories/translate-loader.factory';
import { AdminGuard } from './guards/admin.guard';
import { LoggedInGuard } from './guards/logged-in.guard';
import { NotLoggedInGuard } from './guards/not-logged-in.guard';
import { AuthHttpService } from './services/api/auth-http.service';
import { CheckHttpService } from './services/api/check-http.service';
import { CompanyHttpService } from './services/api/company-http.service';
import { EmployeeHttpService } from './services/api/employee-http.service';
import { NotificationHttpService } from './services/api/notification-http.service';
import { UserHttpService } from './services/api/user-http.service';
import { RefreshTokenService } from './services/authentication/refresh-token.service';
import { httpServiceFactory } from './services/base/http-service.factory';
import { HttpService } from './services/base/http.service';
import { PendingService } from './services/base/pending.service';
import { ValidationService } from './services/validation/validation.service';
import { ToasterService } from './services/visual/toaster.service';

@NgModule({
  imports: [
    AgmCoreModule.forRoot(),
    HttpModule,
    HttpClientModule,
    ToastrModule.forRoot({
      timeOut: environment.toasterTimeout,
      positionClass: 'toast-top-center',
      preventDuplicates: false,
    }),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: createTranslateLoader,
        deps: [ HttpClient ]
      }
    })
  ],
  providers: [
    // Config
    {
      provide: LAZY_MAPS_API_CONFIG,
      useClass: GoogleMapsConfig
    },
    // Services
    {
      provide: HttpService,
      useFactory: httpServiceFactory,
      deps: [ XHRBackend, RequestOptions, Router, RefreshTokenService, PendingService ]
    },
    AuthHttpService,
    CheckHttpService,
    CompanyHttpService,
    EmployeeHttpService,
    NotificationHttpService,
    PendingService,
    RefreshTokenService,
    ToasterService,
    UserHttpService,
    ValidationService,
    // Guards
    AdminGuard,
    LoggedInGuard,
    NotLoggedInGuard
  ]
})
export class CoreModule { }



// WEBPACK FOOTER //
// /var/www/lantago-app/lantago-app-demo/src/app/core/core.module.ts